import {Collapsible as CollapsiblePrimitive} from "@base-ui/react/collapsible";
import {clsx} from "clsx";
import styles from "./Collapsible.module.css";

type CollapsibleProps = CollapsiblePrimitive.Panel.Props & Pick<CollapsiblePrimitive.Root.Props, "open">;

// Slides its content in and out by animating the height instead of popping it in.
function Collapsible({open, className, ...props}: CollapsibleProps) {
	return (
		<CollapsiblePrimitive.Root open={open}>
			<CollapsiblePrimitive.Panel data-slot="collapsible" className={clsx(styles.collapsible, className)} {...props}/>
		</CollapsiblePrimitive.Root>
	);
}

export {Collapsible};
